/**
 * Router Reducer
 *
 * Maintains router state in Redux for backward compatibility with connected-react-router.
 * Listens to @@router/LOCATION_CHANGE actions dispatched by LocationChangeDispatcher.
 */

interface RouterLocation {
  pathname: string
  search: string
  hash: string
  state?: any
  key?: string
}

interface RouterState {
  location: RouterLocation
  action: string
}

interface LocationChangeAction {
  type: '@@router/LOCATION_CHANGE'
  payload: {
    location: RouterLocation
    action: string
    isFirstRendering: boolean
  }
}

const initialState: RouterState = {
  location: {
    pathname: '/',
    search: '',
    hash: '',
    state: undefined,
    key: undefined,
  },
  action: 'POP',
};

export function routerReducer(
  state: RouterState = initialState,
  action: LocationChangeAction | any,
): RouterState {
  if (action.type === '@@router/LOCATION_CHANGE') {
    return {
      location: action.payload.location,
      action: action.payload.action,
    };
  }

  return state;
}
